import { Typography } from '@mui/material';
import { ConfirmationDialog } from '../../../common/components';

const DeletePaymentOrderDialog = ({ open, order, onCancel, onConfirm, isDeleting }) => (
  <ConfirmationDialog
    open={open}
    title="Eliminar orden de pago"
    message={
      <Typography>
        ¿Seguro que deseas eliminar la orden de pago{' '}
        <strong>#{order?.order_number ?? ''}</strong>? Los movimientos asociados permanecerán
        registrados pero se desvincularán de la orden.
      </Typography>
    }
    confirmText="Eliminar"
    cancelText="Cancelar"
    onClose={onCancel}
    onConfirm={onConfirm}
    isLoading={isDeleting}
  />
);

export default DeletePaymentOrderDialog;
